import 'COMMON';
import { oLike } from 'Lib/like/like';
import 'Vendor/polifill-object-fit-images/polifill-object-fit-images';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/journal/video/video';
import 'Bem/journal/text-insert/text-insert';
import 'Bem/journal/gallery/gallery';
import 'Bem/journal/note/note';
import 'Bem/journal/articles/articles';
import 'Bem/site/subscribe-btn/subscribe-btn'; // Удалить EKSMORU-2301
import 'Bem/journal/metronom/metronom';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/journal/table-list/table-list';
import 'Bem/journal/text-insert-card/text-insert-card';
import 'Bem/journal/fixed-menu/fixed-menu';
import 'Bem/site/copy/copy';
import 'Bem/site/form-custom/form-custom';
import 'Bem/journal/text-insert-article/text-insert-article';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/promo/promo';
import 'Bem/journal/article-t/article-t';
import 'Bem/site/popup-subscribe/popup-subscribe';
import { Reactions } from 'Lib/reactions/reactions';
import 'Bem/site/sales-book/sales-book';
import 'Bem/site/reviews/reviews';
import 'Bem/site/form-bg/form-bg';
import 'Bem/site/spoiler/spoiler';
import 'Bem/journal/text-insert-min/text-insert-min';
import 'Bem/site/accordion/accordion';
import { PopupVideo } from 'Lib/popup/popup-video';

const $body = $('body');
let reactions = new Reactions(document.querySelectorAll('.reactions'));
const popupVideo = new PopupVideo();

popupVideo.popupVideoOpenDefault();
reactions.init();

$body.on('init.fastViewBook', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
});

svgSpriteLoader('/journal/article/svg/sprite.svg?v=20180320');
oLike.init('.js-book-like, .js-article-like');

$body.on('eksmoPagenavAjax', () => {
    oLike.init('.js-book-like, .js-article-like');
    popupVideo.popupVideoOpenDefault();
});